import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface IProps {
  title: string
  rootClass?: string | (string | Record<PropertyKey, boolean>)[] | Record<PropertyKey, boolean>
  hoverless?: false
  icon?: string
  size?: 'lg' | 'sm'
  disable?: boolean
  active?: boolean
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KCheckoutButton' },
  __name: 'KCheckoutButton',
  props: {
    title: {},
    rootClass: { default: '' },
    hoverless: { type: Boolean, default: false },
    icon: { default: '' },
    size: { default: 'lg' },
    disable: { type: Boolean, default: false },
    active: { type: Boolean, default: false }
  },
  emits: ['action'],
  setup(__props: any) {







return (_ctx: any,_cache: any) => {
  const _component_KIcon = _resolveComponent("KIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["k-checkout-button bg-white-shadow shadow-1 flex flex-center cursor-pointer transition", [
      __props.rootClass,
      { 'k-checkout-button__hoverless': __props.hoverless },
      { 'k-checkout-button__disable': __props.disable },
      { 'k-checkout-button__active': __props.active },
      __props.size === 'lg'
        ? 'k-checkout-button--lg q-px-52 q-py-xl gap-20 rounded-32 column no-wrap'
        : 'k-checkout-button--sm q-px-sm q-py-12 gap-sm rounded-16',
    ]]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (!__props.disable && _ctx.$emit('action')))
  }, [
    _renderSlot(_ctx.$slots, "icon", {}, () => [
      _createVNode(_component_KIcon, {
        name: __props.icon,
        size: __props.size === 'lg' ? '64px' : '32px',
        color: __props.disable ? 'cool-gray-60' : ''
      }, null, 8, ["name", "size", "color"])
    ]),
    _createElementVNode("span", {
      class: _normalizeClass([
        'transition',
        __props.size === 'lg' ? 'fw-600 fs-19px' : 'fw-500 fs-15px ',
        __props.disable ? 'text-cool-gray-60' : __props.active ? 'text-space-b-100' : 'text-cool-gray-100',
      ])
    }, _toDisplayString(__props.title), 3)
  ], 2))
}
}

})